import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageKeys } from '../enums/storage-keys.enum';
import { UrlKeys } from '../enums/urls.enum';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';

export const comoEnCasaGuard: CanActivateFn = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const logData = inject(StorageService).sessionStorageGetItem(StorageKeys.LOGIN_DATA);
  return inject(AuthService).isLogged() && !logData.isPremember
    ? true
    : inject(Router).createUrlTree([`/${UrlKeys.HOME}`]);
};
